export class AuditResource {
  entityId: number;
  type: string;
  description: string;
  auditTrail: string;
  created: Date;
  createdBy: string;

  constructor(data: any = {}) {
    this.entityId = data.entityId || null;
    this.type = data.type || null;
    this.description = data.description ? data.description : null;
    this.auditTrail = data.auditTrail ? data.auditTrail : null;
    this.created = data.created ? new Date(data.created) : null;
    this.createdBy = data.createdBy || null;
  }
}
